"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductFormButton = void 0;
const utils_1 = require("../../utils/utils");
const base_component_1 = require("../../components/base-component");
const FOOTER_SELECTOR = '.shopify-section.shopify-section-footer';
const FORM_SELECTOR = 'product-form';
const VARIANT_CHOOSE_BUTTONS_SELECTOR = "[data-product-card-variant-selection]";
const VARIANT_PICKER_DRAWER_TOGGLES_SELECTOR = '[data-toggle-variant-picker-drawer]';
class ProductFormButton extends base_component_1.BaseComponent {
    mountComponent() {
        const variantChooseButtons = (0, utils_1.$list)(VARIANT_CHOOSE_BUTTONS_SELECTOR, this);
        const variantPickerDrawerToggles = (0, utils_1.$list)(VARIANT_PICKER_DRAWER_TOGGLES_SELECTOR, this);
        this.addListener(window, 'scroll', this.handleWindowScroll);
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.handleResizeVisualViewport);
            this.handleResizeVisualViewport();
        }
        this.handleStickySelectVariant();
        variantChooseButtons.forEach(variantChooseButton => this.addListener(variantChooseButton, 'click', () => {
            this.handleVariantBtnClick(variantChooseButton);
        }));
        variantPickerDrawerToggles.forEach(variantPickerDrawerToggle => this.addListener(variantPickerDrawerToggle, 'click', () => {
            this.toggleVariantPickerDrawer(variantPickerDrawerToggle);
        }));
    }
    handleVariantBtnClick = (variantChooseButton) => {
        const inputRelated = (0, utils_1.$el)(`input#${variantChooseButton.getAttribute('for')}`, this);
        inputRelated?.click();
        const variantId = inputRelated?.getAttribute('value');
        if (!variantId)
            return;
        const form = (0, utils_1.$el)('form#' + variantChooseButton.dataset.productFormId, this.closest("product-form"));
        if (!form)
            return;
        form.dispatchEvent(new CustomEvent('lbc-submit', { bubbles: true, detail: { button: variantChooseButton } }));
    };
    async updateVariantPickerDrawer(btn) {
        const productUrl = btn.getAttribute('data-product-url');
        await fetch(productUrl + "?section=variant-picker-drawer&lbc_product_form_id=" + btn.getAttribute('data-product-form-id'))
            .then(response => response.text())
            .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            let variantPickerDrawerInMainHTML = document.querySelector('.variant-picker-drawer');
            if (variantPickerDrawerInMainHTML) {
                const headerTitle = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__header-title');
                const content = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__content');
                headerTitle.innerHTML = doc.querySelector('.variant-picker-drawer__header-title').innerHTML;
                content.innerHTML = doc.querySelector('.variant-picker-drawer__content').innerHTML;
            }
            else {
                document.body.insertAdjacentHTML('beforeend', doc.body.innerHTML);
            }
            variantPickerDrawerInMainHTML = document.querySelector('.variant-picker-drawer');
            const variantPickerDrawerToggles = variantPickerDrawerInMainHTML.querySelectorAll('[data-toggle-variant-picker-drawer]:not([data-toggle-variant-picker-drawer-initialized]');
            variantPickerDrawerToggles.forEach((toggle) => {
                toggle.setAttribute('data-toggle-variant-picker-drawer-initialized', '');
                toggle.addEventListener('click', () => {
                    this.toggleVariantPickerDrawer(toggle);
                });
            });
            const variantPickerDrawerOverlayInMainHTML = document.querySelector('.variant-picker-drawer__overlay:not([data-toggle-variant-picker-drawer-initialized]');
            if (variantPickerDrawerOverlayInMainHTML) {
                variantPickerDrawerOverlayInMainHTML.setAttribute('data-toggle-variant-picker-drawer-initialized', '');
                variantPickerDrawerOverlayInMainHTML.addEventListener('click', () => {
                    this.toggleVariantPickerDrawer(variantPickerDrawerOverlayInMainHTML);
                });
            }
            const variantPickerDrawerButtons = variantPickerDrawerInMainHTML.querySelectorAll('[data-product-card-variant-selection]');
            variantPickerDrawerButtons.forEach((variantPickerDrawerButton) => {
                variantPickerDrawerButton.setAttribute('data-product-form-id', btn.getAttribute('data-product-form-id'));
                variantPickerDrawerButton.addEventListener('click', () => {
                    this.handleVariantBtnClick(variantPickerDrawerButton);
                });
            });
            const variantPickerDrawerContent = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__content');
            const variantPickerDrawerContentInner = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__content__inner');
            // Check if the variant picker drawer content has overflow
            if (variantPickerDrawerContentInner.scrollHeight > variantPickerDrawerContentInner.clientHeight) {
                variantPickerDrawerContent.classList.add('variant-picker-drawer__content--with-overflow');
            }
            if (variantPickerDrawerContentInner) {
                variantPickerDrawerContentInner.addEventListener('scroll', () => {
                    if (variantPickerDrawerContentInner.scrollHeight - variantPickerDrawerContentInner.scrollTop === variantPickerDrawerContentInner.clientHeight) {
                        variantPickerDrawerContent.classList.remove('variant-picker-drawer__content--with-overflow');
                    }
                    else {
                        variantPickerDrawerContent.classList.add('variant-picker-drawer__content--with-overflow');
                    }
                });
            }
        });
    }
    async toggleVariantPickerDrawer(btn) {
        const uploadDrawer = btn.hasAttribute('data-update-variant-picker-drawer');
        if (btn.hasAttribute('data-btn-load-on-click')) {
            btn.classList.add("loading");
        }
        if (uploadDrawer) {
            await this.updateVariantPickerDrawer(btn);
        }
        const variantPickerDrawer = document.querySelector('.variant-picker-drawer');
        const variantPickerDrawerOverlay = document.querySelector('.variant-picker-drawer__overlay');
        if (variantPickerDrawer) {
            variantPickerDrawer.classList.toggle('variant-picker-drawer--open');
        }
        if (variantPickerDrawerOverlay) {
            variantPickerDrawerOverlay.classList.toggle('variant-picker-drawer__overlay--open');
        }
        if (btn.hasAttribute('data-btn-load-on-click')) {
            btn.classList.remove("loading");
        }
    }
    handleStickySelectVariant = () => {
        const stickyBar = this;
        const productInfo = stickyBar.closest(".product__info");
        const productVariantPicker = productInfo.querySelector(".product-variant-picker");
        const productForm = stickyBar.closest("product-form");
        const variantSelectButtons = stickyBar.querySelectorAll(".product-card__variant-select__list__item__button");
        const inputToggleVariantSelect = stickyBar.querySelector(".product-card__variant-select__toggle");
        const label = stickyBar.querySelector(".product-card__variant-select__button span");
        const inputVariantId = productForm.querySelector("input[data-product-form-variant][name='id']");
        variantSelectButtons.forEach((button) => {
            button.addEventListener("click", e => {
                // Update the hidden input with the selected variant ID
                inputVariantId.value = button.getAttribute("data-variant-id");
                label.textContent = button.textContent;
                // Close the select variant dropdown
                inputToggleVariantSelect.checked = false;
                // Update variant in main form
                const matchingVariant = productVariantPicker?.querySelector(`label.pill[data-variant-id="${button.getAttribute("data-variant-id")}"]`);
                matchingVariant?.click();
            });
        });
        if (!inputToggleVariantSelect)
            return;
        // Close the select variant dropdown when clicking outside of it
        document.addEventListener("click", (event) => {
            if (event.target !== inputToggleVariantSelect && !inputToggleVariantSelect.contains(event.target)) {
                inputToggleVariantSelect.checked = false;
            }
        });
    };
    handleWindowScroll = () => {
        const form = (0, utils_1.$elParent)(FORM_SELECTOR, this);
        if (!form) {
            return;
        }
        const footer = (0, utils_1.$el)(FOOTER_SELECTOR);
        const point = form.offsetTop + form.offsetHeight;
        const footerOffsetTop = footer ? footer.offsetTop : 0;
        const isOverFooter = window.innerHeight + window.scrollY < footerOffsetTop;
        const isVisible = isOverFooter && window.scrollY > point;
        this.classList.toggle('is-visible', isVisible);
        document.body.toggleAttribute('is-product-form-button-fixed', isVisible);
        const chatButton = document.querySelector("#chat-button");
        const backToTopButton = document.querySelector(".back-to-top-button");
        if (isVisible) {
            if (chatButton) {
                chatButton.style.bottom = "95px";
            }
            if (backToTopButton) {
                backToTopButton.style.bottom = "95px";
            }
        }
        else {
            if (chatButton) {
                chatButton.style.bottom = "10px";
            }
            if (backToTopButton) {
                backToTopButton.style.bottom = "10px";
            }
        }
    };
    handleResizeVisualViewport = () => {
        if (window.visualViewport) {
            this.style.top = `${window.visualViewport.height}px`;
        }
    };
}
exports.ProductFormButton = ProductFormButton;
